'use client';
import React from 'react';
import { Search, SlidersHorizontal, ChevronDown } from 'lucide-react';

const sortOptions = [
  { value: 'popularity', label: 'Most Popular' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'rating', label: 'Highest Rated' },
  { value: 'capacity', label: 'Largest Capacity' },
  { value: 'newest', label: 'Newest First' },
];

type Props = {
  searchQuery: string;
  setSearchQuery: (v: string) => void;
  sortBy: string;
  setSortBy: (v: string) => void;
  onOpenMobileFilters: () => void;
  activeFilterCount: number;
};

export default function ListingHeader({
  searchQuery,
  setSearchQuery,
  sortBy,
  setSortBy,
  onOpenMobileFilters,
  activeFilterCount,
}: Props) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-4 md:p-5">
      <div className="flex flex-col md:flex-row gap-3 items-stretch md:items-center">
        {/* Search */}
        <div className="flex-1 relative">
          <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search venues by name or location..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 text-sm border-2 border-gray-100 hover:border-red-200 focus:border-red-400 rounded-xl outline-none transition-colors font-medium text-gray-900 placeholder-gray-400"
          />
        </div>

        <div className="flex items-center gap-3">
          {/* Sort */}
          <div className="relative">
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="appearance-none pl-4 pr-8 py-2.5 text-sm font-semibold border-2 border-gray-100 hover:border-red-200 rounded-xl outline-none transition-colors text-gray-700 bg-white cursor-pointer"
            >
              {sortOptions.map((opt) => (
                <option key={`sort-${opt.value}`} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <ChevronDown size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
          </div>

          {/* Mobile Filter Button */}
          <button
            onClick={onOpenMobileFilters}
            className="lg:hidden relative flex items-center gap-2 px-4 py-2.5 bg-red-600 text-white font-semibold text-sm rounded-xl hover:bg-red-700 transition-colors"
          >
            <SlidersHorizontal size={15} />
            Filters
            {activeFilterCount > 0 && (
              <span className="w-5 h-5 bg-white text-red-600 text-xs font-bold rounded-full flex items-center justify-center">
                {activeFilterCount}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mt-3 text-sm text-gray-500">
        <span>Home</span>
        <span>/</span>
        <span className="text-gray-700 font-medium">Venues</span>
      </div>
    </div>
  );
}